/**
 * 语言包映射配置
 */
const langMap = [
    {
        value:'en-US',
        label:'EN'
    },
    {
            value:'zh-CN',
            label:'CN'
    },
    // {
    //     value:'zh-HK',
    //     label:'繁体中文'
    // }
];

export default langMap;
